export default __webpack_public_path__ + "5870cfc9bdf7695eec8fe6630ed1b408.png";